import React from 'react'
import { useTranslation } from 'react-i18next'
import styles from './EventEditor.module.scss'
import locationIcon from 'assets/images/calendar/location-icon.svg'

interface EditEventData {
  location: string | null
  isMyEvent: boolean
}

interface LocationSelectorProps {
  editEventData: EditEventData
  onLocationChange: (location: string) => void
}

const LocationSelector: React.FC<LocationSelectorProps> = ({ editEventData, onLocationChange }) => {
  const { t } = useTranslation()
  return (
    <div className={styles.locationWrapper}>
      <img src={locationIcon} alt="Location" className={styles.titleIcon} />
      <input
        type="text"
        className={`${styles.locationInput} ${!editEventData.isMyEvent ? styles.dimmed : ''}`}
        placeholder={t('calendar.edit.addLocation')}
        value={editEventData.location || ''}
        onChange={(e) => onLocationChange(e.target.value)}
      />
    </div>
  )
}

export default LocationSelector
